module.exports = __webpack_public_path__ + "static/keane-travel-case-study-b709547d6a7d306b0668cc906502a642.jpg";